import React, { ReactNode } from 'react';
import { SessionState } from 'src/common/session/SessionState';
import { useSession } from 'src/common/session/useSession';

interface Props {
    isRole(session: SessionState): boolean;
    fallback?: ReactNode;
}

export const Role: React.FC<Props> = ({
    isRole,
    children,
    fallback = null
}) => {
    const session = useSession();

    if (!isRole(session)) {
        return <>{fallback}</>;
    }
    return <>{children}</>;
};
